import { Injectable } from '@angular/core';
import { ChannelEvent } from './channel.service';

@Injectable({
  providedIn: 'root'
})
export class WatchTowerService {
activated : boolean;
isWatcher : boolean = false;
public _events : any[] = [];


public get events() : any[] {
  return this._events;
}


  constructor() { }
}
